import { useState, useLayoutEffect, useEffect } from "react";
export function useComponentHeight(ref, active) {
    var isActive = active !== null && active !== void 0 ? active : true;
    var _a = useState(undefined), height = _a[0], setHeight = _a[1];
    var updateHeight = function () { var _a; return setHeight((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetHeight); };
    useLayoutEffect(function () {
        window.addEventListener("resize", updateHeight);
        updateHeight();
        return function () { return window.removeEventListener("resize", updateHeight); };
    }, [ref, isActive]);
    useEffect(function () {
        if (isActive && ref)
            updateHeight();
    }, [ref, isActive]);
    return height;
}
